<template>
  <li
    class="additional-field-type rounded-lg pa-6 col-4 "
    :data-qa="`additional-field-type-${item.typeId}`"
    @click="$emit('click', $event)">
    <div class="additional-field-type__title-wrapper d-flex align-start">
      <sIcon
        class="additional-field-type__icon my-auto mx-2"
        :data-qa="`additional-field-type-${item.typeId}-icon`"
        :type="item.icon"/>
      <div
        class="additional-field-type__title h5-headline bold"
        :data-qa="`additional-field-type-${item.typeId}-name`">
        {{ item.name }}
      </div>
    </div>
    <div
      class="additional-field-type__text h7-text "
      :data-qa="`additional-field-type-${item.typeId}-caption`">
      {{ item.caption }}
    </div>
  </li>
</template>
<script>

export default {
  name: 'fieldType',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
}
</script>
<style lang="scss" scoped>
.additional-field-type {
  max-width: 232px;
  background-color: var(--v-secondary__green_chosen-base);

  &:hover {
    cursor: pointer;
    background-color: var(--green_chosen_light);
  }
  &::marker {
    content: '';
  }
}
</style>
